import React, {Fragment, useEffect, useRef, useState} from "react";

import IconClose from "./IconClose";
import {EVENT_ON_CART_CLOSE, EVENT_ON_CART_OPEN, EVENT_ON_ORDER_UPDATE} from "../consts";
import dispatchEvent from "../../components/dispatchEvent";
import getOrder from "../getOrder";
import CartSummaryRow from "./CartSummaryRow";

export default () => {

    const [open, setOpen] = useState(false)
    const [order, setOrder] = useState(null);
    const [po, setPO] = useState('');
    const form = useRef();

    useEffect(() => {
        if (!order) {
            getOrder().then((order) => {
                setOrder(order);
                setPO(order.po ? order.po : '');
            });
        }
    });

    window.addEventListener(EVENT_ON_CART_OPEN, () => {
        setOpen(true);
    });

    window.addEventListener(EVENT_ON_CART_CLOSE, () => {
        setOpen(false);
    });

    window.addEventListener(EVENT_ON_ORDER_UPDATE, (e) => {
        setOrder(e.data);
    });

    const className = open ? 'order-popup is-active' : 'order-popup';

    return <Fragment>
        <div className={className}>
            <div className="wrapper">
                <div className="order-popup__header">
                    <h2 className="order-popup__title">My Order</h2>
                    <div className="order-popup__close-holder js-order-popup-close">
                        <span className="order-popup__close order-popup__close-icon"
                              onClick={(e) => {
                                  dispatchEvent(EVENT_ON_CART_CLOSE)
                              }}>
                            <IconClose />
                        </span>
                        <span className="btn order-popup__close order-popup__close-btn"
                            onClick={(e) => {
                                dispatchEvent(EVENT_ON_CART_CLOSE)
                            }}>Close Cart</span>
                    </div>
                </div>
                {!!(order && order.id) && <div className="order-popup__scroll-align">
                    <div className="order-popup__order-list">
                        {order.items.map((item) => {
                            return <CartSummaryRow item={item} key={`items_${item.id}`} />
                        })}
                    </div>
                    <div className="order-popup__action">
                        <div className="order-popup__po">
                            <input type={'text'}
                                   placeholder={'PO Number'}
                                   value={po}
                                   onChange={(e) => {
                                       setPO(e.target.value)
                                   }} />
                        </div>
                        <a href="#" onClick={(e) => {
                            e.preventDefault();
                            if (form.current) {
                                form.current.submit();
                            }
                            return false;
                        }} className="btn">Submit order</a>
                    </div>

                    <form ref={form} method="post" action="orders-api/submit-order">
                        <input type={'hidden'} name="po_number" value={po}/>
                    </form>

                </div>}
            </div>
        </div>
        <div className="order-popup__bg-close"
             onClick={(e) => {
                 dispatchEvent(EVENT_ON_CART_CLOSE)
             }}/>
    </Fragment>


}
